module.exports = __webpack_public_path__ + "static/media/cancel-white.b88353f5.svg";